// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1779125601761
      var cssReload = require("/home/runner/_work/cci-tws-stipulator/cci-tws-stipulator/stipulator-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"/../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  